import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_QUOTE_CONTENT_SNIPPET = gql`
  mutation createQuoteContentSnippet(
    $containerId: Int!
    $visible: Boolean!
    $text: String!
    $author: String!
  ) {
    contentSnippet {
      createContentSnippet(
        baseSnippet: { containerId: $containerId, visible: $visible }
        contentSnippetQuote: { text: $text, author: $author }
      ) {
        id
        sort
      }
    }
  }
`;

const createQuoteContentSnippetRequest = ({
  containerId,
  isVisible,
  text,
  author,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_QUOTE_CONTENT_SNIPPET}>
    {(createContentSnippet, { loading, error, data }) => {
      const variables = {
        containerId,
        visible: isVisible,
        text,
        author,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.contentSnippet.createContentSnippet.id,
          data.contentSnippet.createContentSnippet.sort
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentSnippet}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createQuoteContentSnippetRequest.propTypes = {
  author: PropTypes.string.isRequired,
  containerId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
};

createQuoteContentSnippetRequest.defaultProps = {
  isVisible: true,
};

export default createQuoteContentSnippetRequest;
